//签到状态
const signStatusUrl = `/gateway/hc-accumulated/dailyPerf/getSignInStatus`;
//签到
const signUrl = `/gateway/hc-accumulated/dailyPerf/doSignIn`;
//每日任务
const dayMaskUrl = `/gateway/hc-accumulated/dailyPerf/getSignInStatus`;
//是否显示评论
const isShowSign = `/gateway/blade-system/application/getFunctionSetting`;
export { signStatusUrl, signUrl, dayMaskUrl, isShowSign };
